import React, { useEffect, useState } from "react";
import "./About.styles.css";
import about_fuss from "../../assets/images/about/about_fuss.jpg";
import SEO from "../../utils/SEO";

const AboutPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <SEO title="About Page" description="description"/> */}
      <div className="cm-about-page-container">
        <div className="inner-banner">
          <h2 className="cm-section-h cm-txt-center cm-white-col">About Us</h2>
        </div>

        <div className="cm-section cm-about-us-container">
          <div className="cm-page-center cm-flex-type-1">
            <div className="cm-left-col">
              <h2 className="cm-section-h">
                Grab The Best Airfare Deals And Start Your Journey With Airefare
              </h2>
              <p className="cm-section-sp">
                Airefare is a trusted online platform that helps travelers to
                find the best airfare deals and convenient flight booking
                options for various destinations. We always aim to simplify the
                travel-planning process by offering affordable flights, flexible
                booking options, and reliable customer support.
              </p>
              <p className="cm-section-sp">
                Whether you are traveling for business, leisure, or a family
                vacation, Airefare always works to ensure that every traveler
                can explore destinations without worrying about the high ticket
                prices. Our platform helps travellers to compare flight options,
                choose the best fares, and book tickets quickly and securely.
              </p>
            </div>
            <div className="cm-right-col">
              <i className="fa-solid fa-plane-circle-check cm-flex-type-2 cm-prim-bg cm-white-col"></i>
            </div>
          </div>
        </div>

        <div className="service_section">
          <div className="cm-page-center">
            <h2>Why Choose Airefare?</h2>
            <div className="cm-flex cm-flex-wrap">
              <div className="cm-wd-25">
                <i className="fa-solid fa-tag"></i>
                <h5>Affordable Flight Deals</h5>
                <p>
                  Airefare focuses on helping travelers find the best airfare
                  deals across multiple destinations and airline partners.
                </p>
              </div>
              <div className="cm-wd-25">
                <i className="fa-solid fa-circle-check"></i>
                <h5>Smooth Booking Experience</h5>
                <p>
                  Our platform is designed to make flight searching and booking
                  simple, fast, and convenient for every traveler.
                </p>
              </div>
              <div className="cm-wd-25">
                <i className="fa-solid fa-heart"></i>
                <h5>Wide Range Of Travel Options</h5>
                <p>
                  We provide access to a broad selection of airlines, routes,
                  and schedules to match your travel preferences.
                </p>
              </div>
              <div className="cm-wd-25">
                <i className="fa-solid fa-clock"></i>
                <h5>Dedicated Customer Support</h5>
                <p>
                  Our travel support team is available to assist you with
                  bookings, changes, cancellations, and other travel inquiries.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="cm-section cm-about-fuss-container">
          <div className="cm-page-center cm-flex-type-1">
            <div className="cm-left-col">
              <img
                src={about_fuss}
                alt="Fuss-Free Flight Booking"
                className="box-shadow-2"
              />
            </div>
            <div className="cm-right-col">
              <h2 className="cm-section-h">
                Hassle-Free Flight Booking For Every Traveler
              </h2>
              <p>
                Travel is an important part of our lives, whether it involves
                business meetings, family gatherings, or well-deserved
                vacations. At Airefare, we understand the importance of a smooth
                travel planning process.
              </p>
              <p>
                Our goal is to provide travelers with reliable flight booking
                services and competitive airfare options. By offering amazing
                deals and helpful support, we aim to make your flight booking
                experience simple and stress-free. With Airefare, you can focus
                more on enjoying your journey and less on worrying about the
                booking process.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
